import React, { useMemo } from 'react';
import { ThemeProvider } from 'styled-components';
import { Typography } from 'antd';
import { useTheme } from '../../../context/ThemeContext';
import Table from '../../../commonComponents/Table';
import { StyledCard, TableWrapper, EmptyStateText } from './Styles';
import { addCommasInPrices, ITEM_TABLE_COLUMNS, EMPTY_STATE_MESSAGES } from './constants';
import { ItemSalesSectionProps } from './types';

const { Title } = Typography;

const ItemSalesSection: React.FC<ItemSalesSectionProps> = ({
  reportData,
  loading = false,
}) => {
  const { isDarkMode } = useTheme();
  const theme = { mode: (isDarkMode ? 'dark' : 'light') as 'light' | 'dark' };

  const tableData = useMemo(() => {
    if (!reportData?.itemSales?.items || reportData.itemSales.items.length === 0) {
      return [];
    }

    return reportData.itemSales.items.map((item, index) => ({
      key: `item-${index}`,
      name: item.name || 'Unknown',
      revenue: `$${addCommasInPrices(item.revenue || 0)}`,
      quantity: item.quantity || 0,
      price: `$${addCommasInPrices(item.price || 0)}`,
    }));
  }, [reportData?.itemSales]);

  if (tableData.length === 0) {
    return (
      <ThemeProvider theme={theme}>
        <StyledCard title={<Title level={4} style={{ margin: 0 }}>Top Items</Title>}>
          <EmptyStateText>{EMPTY_STATE_MESSAGES.ITEM_SALES}</EmptyStateText>
        </StyledCard>
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <StyledCard title={<Title level={4} style={{ margin: 0 }}>Top Items</Title>}>
        <TableWrapper>
          <Table
            columns={ITEM_TABLE_COLUMNS}
            dataSource={tableData}
            rowKey={(record) => record.key}
            loading={loading}
            pagination={false}
            emptyText="No item sales data available"
            emptyDescription={EMPTY_STATE_MESSAGES.ITEM_SALES}
            scroll={{ x: true, y: 400 }}
            theme={isDarkMode ? 'dark' : 'light'}
            size="middle"
            headerBackgroundColor={isDarkMode ? '#1a202c' : '#F2F2F2'}
            removeVerticalBorders={true}
            thPadding="15px 10px"
            tdPadding="10px 10px"
            firstChildBorderRadius="8px"
            border="0"
            borderBottomLeftRight={true}
          />
        </TableWrapper>
      </StyledCard>
    </ThemeProvider>
  );
};

export default ItemSalesSection;
